import { EventBus } from '../utils/EventBus';
import { GameEvents } from '../core/types';
import { SaveSystem } from './SaveSystem';

export class EconomySystem {
    private static instance: EconomySystem;
    private coins: number = 0;
    private gems: number = 0;

    private constructor() {
        this.load();
    }

    static getInstance(): EconomySystem {
        if (!EconomySystem.instance) {
            EconomySystem.instance = new EconomySystem();
        }
        return EconomySystem.instance;
    }

    addCoins(amount: number) {
        this.coins += amount;
        this.save();
        EventBus.emit(GameEvents.CoinsChanged, this.coins);
    }

    removeCoins(amount: number) {
        if (this.coins >= amount) {
            this.coins -= amount;
            this.save();
            EventBus.emit(GameEvents.CoinsChanged, this.coins);
        }
    }

    getCoins(): number {
        return this.coins;
    }

    addGems(amount: number) {
        this.gems += amount;
        this.save();
    }

    getGems(): number {
        return this.gems;
    }

    canAfford(price: number, currency: 'coins' | 'gems'): boolean {
        if (currency === 'coins') return this.coins >= price;
        return this.gems >= price;
    }

    purchase(price: number, currency: 'coins' | 'gems'): boolean {
        if (this.canAfford(price, currency)) {
            if (currency === 'coins') {
                this.removeCoins(price);
            } else {
                this.gems -= price;
                this.save();
            }
            return true;
        }
        return false;
    }

    private load() {
        const profile = SaveSystem.getInstance().load();
        this.coins = profile.coins;
        this.gems = profile.gems;
    }

    private save() {
        const profile = SaveSystem.getInstance().load();
        profile.coins = this.coins;
        profile.gems = this.gems;
        SaveSystem.getInstance().save(profile);
    }
}
